import axios, { AxiosRequestConfig, Method } from "axios";
import { toast } from "react-toastify";

// Define the response structure
interface ApiResponse<T = any> {
  [x: string]: any;
  status: string;
  message: string;
  data?: T;
}

// Define the service function type
interface AuthApiServiceParams {
  method: Method;
  endpoint: string;
  data?: any;
  headers?: Record<string, string>;
  lang?: string;
  apiHeaders: {
    token?: string;
    clientSlug?: string;
    locale?: string;
    clientId?: string;
  };
}

const authApiService = async <T = any>({
  method,
  endpoint,
  data = null,
  headers = {},
  lang = "",
  apiHeaders,
}: AuthApiServiceParams): Promise<ApiResponse<T>> => {
  // Ensure backEndPoint is defined (consider using a type assertion or environment config)
  const url = `${process.env.backEndPoint}${endpoint}`;

  // Safely retrieve client_id and locale
  const client_id = apiHeaders.clientId || "";
  const locale = lang || apiHeaders.locale || "";

  // Prepare headers
  const requestHeaders: Record<string, string | number> = {
    ...headers,
    clientId: client_id,
    lang: locale,
  };

  try {
    const axiosConfig: AxiosRequestConfig = {
      method,
      url,
      data,
      headers: requestHeaders,
    };

    const response = await axios(axiosConfig);
    const result = response.data.response as ApiResponse<T>;

    if (result.status === "OK") {
      return result;
    } else {
      throw new Error(result.message);
    }
  } catch (error: any) {
    if (error.response?.status === 404) {
      window.location.href = `/${locale}/not-found`;
    }

    throw error.response?.data?.response || error;
  }
};

export default authApiService;
